var RequisitionsInfiniteScrollContainer = /** @class */ (function () {
    function RequisitionsInfiniteScrollContainer(userId, companyId, jobService, alertsAndNotificationsService, isStaffingCompany) {
        this.jobService = jobService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.isStaffingCompany = isStaffingCompany;
        this.userId = userId;
        this.companyId = companyId;
        this.$onInit();
    }
    RequisitionsInfiniteScrollContainer.prototype.$onInit = function () {
        this.requisitions = [];
        this.requisitionsPerPage = [];
        this.busy = false;
        this.loadingSearchButton = false;
        this.requisitionsExistFlag = true;
        this.currentPromise = null;
        this.disableInfiniteScroll = false;
        this.requisitionCount = 0;
        this.isFilterOn = false;
    };
    RequisitionsInfiniteScrollContainer.prototype._getRequisitions = function (successCallback, errorCallback) {
        this.currentPromise = this.jobService.searchJobsByText(this.userId, this.companyId, this.requisitionsQueryFilter.searchText, this.requisitionsQueryFilter, function (data) {
            if (successCallback) {
                successCallback(data);
            }
        }, function (error) {
            if (errorCallback) {
                errorCallback(error);
            }
        });
    };
    RequisitionsInfiniteScrollContainer.prototype.getNext = function () {
        var _this = this;
        if (this.busy)
            return;
        this.busy = true;
        if (this.requisitionsQueryFilter.pageNum == '') {
            this.requisitionsQueryFilter.pageNum = 1;
        }
        this._setIsFilterOn();
        this._getRequisitions(function (data) {
            if (angular.isDefined(data) && data != 'user cancellation') {
                _this.requisitionCount = data.totalCount;
                if (data.jobDetails.length > 0) {
                    angular.forEach(data.jobDetails, function (val, key) {
                        val.requisitionIndex = (_this.requisitions.length + 1);
                        _this.requisitions.push(val);
                    });
                    if (data.jobDetails.length < _this.requisitionsQueryFilter.size) {
                        _this.disableInfiniteScroll = true;
                    }
                    else {
                        _this.requisitionsQueryFilter.pageNum++;
                    }
                }
                else {
                    _this.disableInfiniteScroll = true;
                }
                if (_this.requisitions.length > 0) {
                    _this.requisitionsExistFlag = true;
                }
                else {
                    _this.requisitionsExistFlag = false;
                }
            }
            _this.busy = false;
            _this.loadingSearchButton = false;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    RequisitionsInfiniteScrollContainer.prototype.getNextPage = function (currentPage) {
        var _this = this;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (this.busy)
            return;
        this.busy = true;
        this.requisitionsQueryFilter.pageNum = currentPage ? currentPage : 1;
        this.requisitionsPerPage = [];
        this._getRequisitions(function (data) {
            if (angular.isDefined(data) && data != 'user cancellation') {
                _this.requisitionCount = data.totalCount;
                angular.forEach(data.jobDetails, function (val, key) {
                    _this.requisitionsPerPage.push(val);
                });
                if (_this.requisitionsPerPage.length > 0) {
                    _this.requisitionsExistFlag = true;
                }
                else {
                    _this.requisitionsExistFlag = false;
                }
            }
            _this.busy = false;
            _this.loadingSearchButton = false;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    RequisitionsInfiniteScrollContainer.prototype._setIsFilterOn = function () {
        var filter = this.requisitionsQueryFilter;
        if (filter.clientOrBU.length > 0
            || filter.roleList.length > 0
            || filter.requisitionNums.length > 0
            || filter.recruiters.length > 0
            || filter.requisitionTypes.length > 0
            || filter.jobTypes.length > 0
            || filter.requisitionStates.length > 0
            || filter.searchText.length > 0
            || (!filter.isAssignedToMe && this.isStaffingCompany)
            || (!filter.isAssignedToOthers && this.isStaffingCompany)
            || (!filter.isUnassigned && this.isStaffingCompany)
            || filter.sortColumn !== "" && filter.sortDirection !== ""
            || filter.workLocationIds.length > 0) {
            this.isFilterOn = true;
        }
        else {
            this.isFilterOn = false;
        }
    };
    return RequisitionsInfiniteScrollContainer;
}());
export { RequisitionsInfiniteScrollContainer };
//# sourceMappingURL=requisitions-infinite-scroll-container.js.map